import { useNavigate } from "react-router-dom";
import "./Card.css";
import React, { useState } from "react";

const Cards = ({ cards, callBackFunction, showBorder }) => {
  const navigate = useNavigate();
  const [selectedCard, setSelectedCard] = useState(Number(localStorage.getItem("activeCard"))||0);
  const handleCardClick = (index, title, url) => {
    if (callBackFunction) {
      callBackFunction(index, title, url);
      setSelectedCard(index);
      localStorage.setItem("activeCard",index)
    } else {
      navigate(url, { state: title });
    }
    
  };

  return (
    <div className="card-grid-container">
      <div className="card-grid">
        {cards.map((card, index) => (
          <div
            name={card.title}
            className={`card  ${showBorder && (selectedCard === index) ? "selected" : ""}`}
            key={index}
            onClick={() => handleCardClick(index, card.title, card.url)}
          >
            <div className="card-header">
              <h3>{card.title}</h3>
            </div>
            <div className="card-content">
              <p className="value-number">{card.value}</p>
              <p className="card-description">{card.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Cards;
